/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReimbursementType } from './ReimbursementType';
import {
    ReimbursementTypeFromJSON,
    ReimbursementTypeFromJSONTyped,
    ReimbursementTypeToJSON,
    ReimbursementTypeToJSONTyped,
} from './ReimbursementType';

/**
 * 
 * @export
 * @interface PayerContract
 */
export interface PayerContract {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    type: PayerContractTypeEnum;
    /**
     * 
     */
    reimbursement_type: ReimbursementType;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    s3_access_url?: string;
    /**
     * 
     */
    expiry_date?: string | null;
    /**
     * 
     */
    processing_status?: PayerContractProcessingStatusEnum;
    /**
     * 
     */
    processing_error?: PayerContractProcessingErrorEnum;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    created_by?: string;
}


/**
 * @export
 */
export const PayerContractTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type PayerContractTypeEnum = typeof PayerContractTypeEnum[keyof typeof PayerContractTypeEnum];

/**
 * @export
 */
export const PayerContractProcessingStatusEnum = {
    Created: 'created',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error',
} as const;
export type PayerContractProcessingStatusEnum = typeof PayerContractProcessingStatusEnum[keyof typeof PayerContractProcessingStatusEnum];

/**
 * @export
 */
export const PayerContractProcessingErrorEnum = {
    Error: 'error',
    InsufficientInfo: 'insufficient_info',
    WrongPayer: 'wrong_payer',
} as const;
export type PayerContractProcessingErrorEnum = typeof PayerContractProcessingErrorEnum[keyof typeof PayerContractProcessingErrorEnum];


/**
 * Check if a given object implements the PayerContract interface.
 */
export function instanceOfPayerContract(value: object): value is PayerContract {
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('reimbursement_type' in value) || value['reimbursement_type'] === undefined) return false;
    return true;
}

export function PayerContractFromJSON(json: any): PayerContract {
    return PayerContractFromJSONTyped(json, false);
}

export function PayerContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): PayerContract {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'payor_id': json['payor_id'],
        'name': json['name'],
        'facility_ids': json['facility_ids'],
        'type': json['type'],
        'reimbursement_type': ReimbursementTypeFromJSON(json['reimbursement_type']),
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        's3_access_url': json['s3_access_url'] == null ? undefined : json['s3_access_url'],
        'expiry_date': json['expiry_date'] === undefined ? undefined : json['expiry_date'] === null ? null : json['expiry_date'],
        'processing_status': json['processing_status'] == null ? undefined : json['processing_status'],
        'processing_error': json['processing_error'] == null ? undefined : json['processing_error'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'created_by': json['created_by'] == null ? undefined : json['created_by'],
    };
}

export function PayerContractToJSON(json: any): PayerContract {
    return PayerContractToJSONTyped(json, false);
}

export function PayerContractToJSONTyped(value?: PayerContract | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payor_id': value['payor_id'],
        'name': value['name'],
        'facility_ids': value['facility_ids'],
        'type': value['type'],
        'reimbursement_type': ReimbursementTypeToJSON(value['reimbursement_type']),
        's3_key': value['s3_key'],
        's3_access_url': value['s3_access_url'],
        'expiry_date': value['expiry_date'],
        'processing_status': value['processing_status'],
        'processing_error': value['processing_error'],
        'created_at': value['created_at'],
        'created_by': value['created_by'],
    };
}

